resourcePaths = '{"rootPath":"","assetsPath":""}';function AggregateCollection() {
    this.extends = [_Input];
    this.node = null;
    this.id = null;
    this.declaredClass = null;

    this._collections = null;
    this._classes = {
      container: 'mogo-ui-aggregate-collection'
    };

    this.init = function() {
      this.containerDiv = this.node;
      this._$node = $(this.node);
      // Add class
      this._$node.addClass(this._classes.container);

      //Find Collections
      this._collections = this._$node.find("[data-mogo-ui=Collection]");
      if (this._collections.length < 2) throw new Error("AggregateCollection is only usefull for 2 or more Collections");

      this._super();

      this._$node.show();
    };

    this.initAllReady = function() {
      this._super();

      var prev = null;
      for (var i = 0; i < this._collections.length; i++ ){
        var current = $(this._collections[i]).mogo();
        current.name = this._$node.attr("name");
        if (prev) {
          prev.onAdd.push(this._updateIndexOffset.bind(this,prev,current));
          prev.onRemove.push(this._updateIndexOffset.bind(this,prev,current));
        }
        prev = current;
      }
    };

    this.val = function(value) {
      if (value) {
        if (Array.isArray(value)) {
          var prev = null;
          this._collections.each(function(i ,el) {
            var current = $(el).mogo();
            current.val(value);
            if (prev) this._updateIndexOffset(prev,current);
            prev = current;
          }.bind(this));
        }
      } else {
        var result = [];
        this._collections.each(function() {
          result = result.concat($(this).mogo().val());
        });
        return result;
      }
    };

    this._updateIndexOffset = function (prev,current) {
      var parentItemNodes = prev._itemNodes;
      current.indexOffset = parentItemNodes ? parentItemNodes.length : 0;
      current._updateNames();
    };

    this.destroy = function() { };
  }
